module.exports = __webpack_public_path__ + "static/media/contact_banner@768.4e079806.png";